<div class="page-container gap-24">
  <div class="page-title">Team</div>

  <div class="portrait-image">
    <img src="assets/images/vanessa.png" alt="Vanessa Portrait" />
  </div>
  <span class="align-self-stretch subtitle">
    Vanessa Diel – Physiotherapeutin & Mitgründerin
  </span>

  <span class="align-self-stretch font-regular-body-large">
    Hi, ich bin Vanessa – Physiotherapeutin aus Leidenschaft und Mitgründerin
    unseres Fortbildungsinstituts. Nach meinem Bachelor-Abschluss in
    Physiotherapie (B.Sc.) 2014 habe ich sieben Jahre lang in orthopädischen
    Praxen gearbeitet, zuletzt in einer Praxis, die sich auf die Behandlung von
    chronischen Schmerzpatient spezialisiert hat. Dort habe ich schnell gemerkt,
    wie wichtig es ist, wissenschaftliche Erkenntnisse in die Therapie
    einzubinden, um wirklich nachhaltige Therapieerfolge zu erzielen.
    <br />
    <br />
    2024 habe ich mit Sabrina das Fortbildungsinstitut gegründet. Mein Ziel?
    Euch ein Angebot zu bieten, das genau das Wissen vermittelt, das in der
    Praxis wirklich einen Unterschied macht. Egal, ob Ihr gerade erst in den
    Beruf startet oder schon viele Jahre dabei seid – hier soll jede*r die
    Möglichkeit haben, sich auf Augenhöhe weiterzubilden.
    <br />
    <br />
    Ich kümmere mich bei uns um die Auswahl der Fortbildungen, die Kommunikation
    mit unseren Dozierenden und alles, was mit Design, Homepage und Organisation
    zu tun hat. Bei der Gestaltung der Seminare lege ich großen Wert darauf,
    dass unsere Inhalte wissenschaftlich fundiert und praktisch umsetzbar sind.
    Mir ist es wichtig, dass Ihr nicht nur Wissen mitnehmt, sondern auch die
    Fähigkeit entwickelt, kritisch auf Studien, Leitlinien und Angebote zu
    schauen. So könnt Ihr selbst entscheiden, was wirklich sinnvoll ist, um Euch
    und Eure Patient*innen weiterzubringen.
    <br />
    <br />
    Ich freue mich, Euch auf Eurem Weg zu begleiten – lasst uns gemeinsam dafür
    sorgen, dass unsere Therapieberufe wachsen und gestärkt werden!
  </span>

  <div class="portrait-image">
    <img src="assets/images/sabrina.png" alt="Sabrina Portrait" />
  </div>

  <span class="align-self-stretch subtitle">
    Sabrina Heizmann – Ergotherapeutin & Mitgründerin
  </span>

  <span class="align-self-stretch font-regular-body-large">
    Hey, ich bin Sabrina – Ergotherapeutin mit Herz und aus Überzeugung! Nach
    meinem Bachelor in Medizinalfachberufe befinde ich mich aktuell im
    Masterstudiengang Ergotherapie an der HAWK. In meiner praktischen Arbeit
    habe ich mich dem Fachbereich Onkologie verschrieben. Neben meinen
    Tätigkeiten als Herausgeberin des Buches „Ergotherapie in der Onkologie“,
    das 2024 im Springer Verlag erschienen ist, Autorin verschiedener
    Fachartikel und Host des Podcasts „Performance Skills“ liegt mir vor allem
    eins am Herzen: evidenzbasiertes Arbeiten, das wirklich etwas bewirkt.
    <br />
    <br />
    Im Institut bin ich für die Qualitätsprüfung und Recherche verantwortlich.
    Ich halte den Überblick, kommuniziere mit unseren Dozierenden und stelle
    sicher, dass alles rund läuft – von To-Do-Listen bis zur Umsetzung unserer
    Vision.
    <br />
    <br />
    Ich bin überzeugt, dass gute Fortbildung nicht nur Wissen vermittelt,
    sondern auch neue Perspektiven eröffnet. Mein Ziel ist es, Euch dabei zu
    unterstützen, mit fundierten, aktuellen und praxisnahen Inhalten die beste
    Version Eurer selbst als Therapeut*in zu werden.
    <br />
    <br />
    Ich freue mich darauf, Euch im Institut willkommen zu heißen und gemeinsam
    an der Weiterentwicklung unserer Berufsfelder zu arbeiten!
  </span>
</div>
